import { Popover } from "radix-ui";

import { type Alignment, setAlign } from "@platejs/basic-styles";
import { useEditorRef, useSelectionFragmentProp } from "platejs/react";

import FontAwesome from "../../../utilities/FontAwesome";
import { ButtonWrapper } from "./_Button";
import styles from "../../styles/SlateEditor.module.scss";
import { useRef, useState } from "react";

const items = [
  {
    icon: <FontAwesome fixedWidth prefix={"fas"} name={"fa-align-left"} />,
    value: "left",
  },
  {
    icon: <FontAwesome fixedWidth prefix={"fas"} name={"fa-align-center"} />,
    value: "center",
  },
  {
    icon: <FontAwesome fixedWidth prefix={"fas"} name={"fa-align-right"} />,
    value: "right",
  },
  {
    icon: <FontAwesome fixedWidth prefix={"fas"} name={"fa-align-justify"} />,
    value: "justify",
  },
];

export function AlignDropdownMenu({ showTooltip }) {
  const editor = useEditorRef();
  const value = useSelectionFragmentProp({
    defaultValue: "start",
    getProp: (node) => node.align,
  });

  const triggerRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);
  const IconValue = items.find((item) => item.value === value)?.icon ?? (
    <FontAwesome fixedWidth prefix={"fas"} name={"fa-align-left"} />
  );

  return (
    <Popover.Root open={open}>
      <Popover.Trigger asChild>
        <ButtonWrapper
          pressed={open}
          tooltip={showTooltip ? "Align" : undefined}
          ref={triggerRef}
          onClick={(e) => {
            e.preventDefault();
            setOpen((v) => !v);
          }}
          className={styles.alignDropdownButton}
        >
          {IconValue}
          <FontAwesome prefix={"fas"} name={"fa-chevron-down"} />
        </ButtonWrapper>
      </Popover.Trigger>
      <Popover.Content
        className={styles.fontSizePopoverContent}
        onPointerDownOutside={(e) => {
          if (
            triggerRef.current &&
            !triggerRef.current.contains(e.target as HTMLElement)
          ) {
            setOpen(false);
          }
        }}
      >
        {items.map(({ icon: Icon, value: itemValue }) => (
          <div key={itemValue}>
            <button
              onClick={() => {
                setAlign(editor, itemValue as Alignment);
                editor.tf.focus();
                setOpen(false);
              }}
            >
              {Icon}
            </button>
          </div>
        ))}
      </Popover.Content>
    </Popover.Root>
  );
}
